import React, { Fragment } from "react";
import { Box, Flex, Text } from "rebass";
import Card from "./Card";

//Assets
//import img1 from "/static/models/textures/bose-cover-immersive-stories.jpg";
//import img2 from "../img/bose/card-image-bose-ds.png";

function INGProjectCards() {
  return (
    <Flex
      flexWrap={["wrap", "wrap", "wrap","nowrap"]}
      variant="container"
      pt={[3, 4]}
      mb={[4, 5]}
      sx={{ gap: [2, 3] }}
      ml={["0", "0", "0", "0", "25ch"]}
    >
      <Box width={[1 / 1, 1 / 1, 1 / 1, 1 / 2, 1 / 3]} mb={[3]}>
        <Card
          sx={{
            backgroundColor: "ingProjectBgDs",
            color: "ingProjectTextDs",
            "& .label": {
            backgroundColor: "ingProjectTextDs",
            color:"ingProjectBgDs"
            },
            "& .label::after": {
            borderLeftColor:"ingProjectTextDs",
            }
          }}
          eyebrow={"Showcase"}
          year={"2024 - 2025"}
          title={"Expressive Brand"}
          page="/work/ing/ing-design-system/"
          info={
            <Fragment>
              <Text as="span">
                <strong>Product Design, Design System</strong>
              </Text>
            </Fragment>
          }
          //img={img2}
        />
      </Box>
    </Flex>
  );
}

export default INGProjectCards;
